import { render, staticRenderFns } from "./Altinn3SystemUserForm.vue?vue&type=template&id=567ae4d2&"
import script from "./Altinn3SystemUserForm.vue?vue&type=script&lang=ts&"
export * from "./Altinn3SystemUserForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports